import { z } from 'zod'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { SignUp } from '@/features/auth/sign-up'

const searchSchema = z.object({
  redirect: z.string().optional(),
})

export const Route = createFileRoute('/(auth)/sign-up')({
  // TEMPORARY: Registration is admin-only while service provider creation moves to admin.
  beforeLoad: () => {
    throw redirect({ to: '/sign-in', replace: true })
  },
  component: SignUp,
  validateSearch: searchSchema,
})
